import { Button, HStack, Text } from '@chakra-ui/react';

export default function PaginateControls({
	setCurrentPage,
	currentPage,
	totalPages,
}) {
	return (
		totalPages > 1 && (
			<HStack justify='center' mt={4}>
				<Button
					size='sm'
					isDisabled={currentPage === 1}
					onClick={() => setCurrentPage((prev) => prev - 1)}
				>
					Anterior
				</Button>
				<Text>
					Página {currentPage} de {totalPages}
				</Text>
				<Button
					size='sm'
					isDisabled={currentPage === totalPages}
					onClick={() => setCurrentPage((prev) => prev + 1)}
				>
					Siguiente
				</Button>
			</HStack>
		)
	);
}
